export default __webpack_public_path__ + "static/media/lifesatisfaction3Img3.7c0bb246.png";